export const iconFontAwesomeNatureBinoculars = (
	<i className="fa-solid fa-binoculars"></i>
);
